document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".slideshow-gulposhii").forEach(slideshow => {
    const slides = slideshow.querySelectorAll(".slideshow-slide");
    const prevBtn = slideshow.querySelector(".slideshow-prev");
    const nextBtn = slideshow.querySelector(".slideshow-next");
    const dotsContainer = slideshow.querySelector(".slideshow-dots");
    const autoplay = slideshow.dataset.autoplay === "true";
    const pauseHover = slideshow.dataset.pauseHover === "true";
    const speed = parseInt(slideshow.dataset.speed, 10) || 5000;

    let index = 0;
    let interval;

    // dots
    if (dotsContainer) {
      slides.forEach((_, i) => {
        const dot = document.createElement("button");
        if (i === 0) dot.classList.add("active");
        dot.addEventListener("click", () => showSlide(i));
        dotsContainer.appendChild(dot);
      });
    }
    const dots = dotsContainer ? dotsContainer.querySelectorAll("button") : [];

    function showSlide(i) {
      // reset old
      slides[index].classList.remove("active");
      if (dots[index]) dots[index].classList.remove("active");

      // pause and detach video listener on old
      slides[index].querySelectorAll("video").forEach(v => {
        v.pause();
        v.currentTime = 0;
        v.removeEventListener("ended", nextSlide);
      });

      index = (i + slides.length) % slides.length;

      // activate new
      slides[index].classList.add("active");
      if (dots[index]) dots[index].classList.add("active");

      const currentVideo = slides[index].querySelector("video");

      if (currentVideo) {
        stopAutoplay(); // timer off during video
        currentVideo.play().catch(() => {});
        currentVideo.addEventListener("ended", nextSlide, { once: true });
      } else {
        startAutoplay();
      }
    }

    function nextSlide() { showSlide(index + 1); }
    function prevSlide() { showSlide(index - 1); }

    if (nextBtn) nextBtn.addEventListener("click", nextSlide);
    if (prevBtn) prevBtn.addEventListener("click", prevSlide);

    function startAutoplay() {
      if (autoplay) {
        stopAutoplay();
        interval = setInterval(nextSlide, speed);
      }
    }
    function stopAutoplay() {
      if (interval) clearInterval(interval);
    }

    if (pauseHover) {
      slideshow.addEventListener("mouseenter", stopAutoplay);
      slideshow.addEventListener("mouseleave", () => {
        const vid = slides[index].querySelector("video");
        if (!vid) startAutoplay();
      });
    }

    // init
    showSlide(0);
  });
});